var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShowroomsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9955 4H7.21752C5.44996 4 4 5.44996 4 7.23133V8.2532C4 10.0208 5.43615 11.4707 7.21752 11.4707H11.9955M11.9955 4V11.4707M11.9955 4H19.991V11.4707H11.9955M20.0045 4H24.7825C26.5639 4 28 5.44996 28 7.21752V8.23939C28 10.0208 26.55 11.4569 24.7825 11.4569H20.0045V4ZM7.23111 11.4709H24.7549V24.1615C24.7549 25.791 23.4292 27.1028 21.8135 27.1028H10.1863C8.55679 27.1028 7.24492 25.7772 7.24492 24.1615V11.4709H7.23111ZM16.0003 18.2352C17.7403 18.2352 19.1488 19.6438 19.1488 21.3837V27.1145H12.8518V21.3837C12.8518 19.6438 14.2604 18.2352 16.0003 18.2352Z",
    stroke: "#76BC21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowroomsIcon);
export default __webpack_public_path__ + "static/media/showroomsIcon.34bf16e360d181349c58b1937083a3ad.svg";
export { ForwardRef as ReactComponent };